import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('logServiceFormFields');

    return {
        ADD_NOTES: t('addNotes'),
        CHOOSE_CALIBRATION_TYPE: t('chooseCalibrationType'),
        CHOOSE_PART: t('choosePart'),
        CHOOSE_UNIT: t('chooseUnit'),
        PHOTOS: t('photos')
    };
};

export default useTranslation;
